import type { DiscoveryProspect, InviteChannel } from '@/api/types';

/**
 * Channel → public profile URL. Prefers an enrichment-supplied URL, otherwise
 * builds the canonical one from the handle so the link always works. Discord
 * has no public profile URL pattern.
 */
export function profileUrl(
  channel: InviteChannel | string,
  handle: string,
  fromEnrichment?: unknown,
): string | null {
  if (typeof fromEnrichment === 'string' && fromEnrichment.startsWith('http')) return fromEnrichment;
  const h = handle.replace(/^@+/, '');
  switch (channel) {
    case 'TIKTOK':
      return `https://www.tiktok.com/@${h}`;
    case 'INSTAGRAM':
      return `https://www.instagram.com/${h}`;
    case 'YOUTUBE':
      return `https://www.youtube.com/@${h}`;
    case 'TWITTER':
      return `https://x.com/${h}`;
    default:
      return null;
  }
}

export function prospectProfileUrl(p: DiscoveryProspect): string | null {
  return profileUrl(p.channel, p.targetIdentifier, p.enrichmentSnapshot?.profileUrl);
}

/** 18200 → "18.2K"; non-numbers → null so the caller can leave the stat out. */
export function compactNumber(n: unknown): string | null {
  if (typeof n !== 'number' || !Number.isFinite(n)) return null;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}
